import React from 'react';
import { MessageInfo } from '@/api/types';
import MediaPreview from './MediaPreview';

interface VoiceMessageProps {
  message: MessageInfo;
  isOwnMessage: boolean;
}

/**
 * 语音消息组件
 */
const VoiceMessage: React.FC<VoiceMessageProps> = ({ message, isOwnMessage }) => {
  const attachment = message.decryptedContentData?.attachment;
  
  if (!attachment?.fileId) {
    return (
      <div className={`px-4 py-2 rounded-2xl ${
        isOwnMessage 
          ? 'bg-red-500 text-white rounded-br-md' 
          : 'bg-red-100 text-red-900 rounded-bl-md'
      }`}>
        <p className="text-sm">语音加载失败</p>
      </div>
    );
  }

  // 格式化时长
  const formatDuration = (seconds?: number) => {
    if (!seconds) return '';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className={`rounded-2xl overflow-hidden ${
      isOwnMessage ? 'rounded-br-md' : 'rounded-bl-md'
    }`}>
      <div className={`px-4 py-3 ${
        isOwnMessage 
          ? 'bg-blue-500 text-white' 
          : 'bg-gray-100 text-gray-900'
      }`}>
        <div className="flex items-center space-x-3 mb-2">
          <svg className={`w-5 h-5 ${isOwnMessage ? 'text-blue-200' : 'text-blue-500'}`} fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
          </svg>
          <span className="text-sm font-medium">语音消息</span>
          {attachment.duration && (
            <span className={`text-xs ${isOwnMessage ? 'text-blue-200' : 'text-gray-500'}`}>
              {formatDuration(attachment.duration)}
            </span>
          )}
        </div>
        <MediaPreview
          fileId={attachment.fileId}
          fileName={attachment.fileName}
          fileSize={attachment.fileSize}
          mediaType="audio"
          className="w-full max-w-xs"
        />
      </div>
    </div>
  );
};

export default VoiceMessage;
